import { motion } from "framer-motion";
import { useInView } from "@/hooks/reveal-in-view";
import React, { FC, useRef } from "react";

export const Tags: FC<{
  className?: string;
  tags: string[];
}> = ({ className, tags }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  const variants = {
    hidden: {
      opacity: 0,
      y: 50,
    },
    visible: (index: number) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: index * 0.25,
        ease: "easeOut",
      },
    }),
  };

  return (
    <div
      className={`tags hide-scrollbar ${className ? className : ""}`}
      ref={ref}
    >
      {tags.map((tag, index) => {
        return (
          <motion.div
            key={index}
            className="tags--item"
            initial="hidden"
            animate={isInView ? "visible" : "hidden"}
            variants={variants}
            custom={index}
            onMouseEnter={(event) => {
              const target = event.currentTarget as HTMLElement;
              target.classList.add("hover-animation-bounce");
            }}
            onAnimationEnd={(event) => {
              const target = event.target as HTMLElement;
              target.classList.remove("hover-animation-bounce");
            }}
          >
            {tag}
          </motion.div>
        );
      })}
    </div>
  );
};
